import styled, { keyframes } from 'styled-components'
import { Breadcrumb, Carousel } from 'antd'

export const Container = styled.div`
  color: var(--black);
  text-align: center;
  background-color: var(--white);
  height: 100%;
  width: 100%;
  padding: 130px 158px 0 158px;
  overflow-x: hidden;

  .link-web {
    display: block;
    color: var(--black);


    u{
      font-weight: 600;
    }
    a {
      color: var(--black);
      margin-left: 8px;

      &:hover {
        color: var(--secondary);
      }
    }

    &.re-entry {
      u {
        color: #EA8B49;
      }

      a {
        &:hover {
          color: #EA8B49;
        }
      }
    }
  }

  .row-top {
    margin-top: 10%;
  }

  .height-row50 {
    height: 52px;
  }
  .height-row75 {
    height: 70px;
  }

  @media only screen and (max-width: 414px) {
    .height-row50 {
      height: 20px !important;
    }
    .height-row75 {
      height: 24px !important;
    }
  }

  @media only screen and (max-width: 820px) {
    .height-row50 {
      height: 50px !important;
    }
    .height-row75 {
      height: 62px !important;
    }
  }

  .row-section {
    display: flex;
  }

  .row-branch {
    margin-top: 10%;
  }

  .row-contact {
    margin-left: 30px;
    margin-top: 80px;
  }
  .row-service {
    margin-left: 30px;
    margin-top: 80px;
  }

  @media only screen and (min-width: 1440px) {
    .col-left-section {
      margin-left: 38px;
    }
  }

  @media only screen and (max-width: 414px) {
    padding: 130px 50px 0 50px !important;

    .row-system {
      img {
        height: 100px !important;
      }

      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }

    .row-section {
      .ant-col-8 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }

    .row-contact {
      margin-left: 0;

      .ant-col-8 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-15 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-offset-1 {
        margin-left: 0;
      }
    }

    .row-service {
      margin-left: 0;

      .ant-col-6 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-9 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }

    .row-structure {
      .ant-col-8 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }

    .row-col-branch {
      .ant-col-11 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-offset-1 {
        margin-left: 0 !important;
      }
    }

    .row-table {
      .ant-col-6 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-17 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-offset-1 {
        margin-left: 0 !important;
      }
    }
  }

  @media only screen and (width: 1024px) and (orientation: portrait) {
    .row-section {
      .ant-col-8 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
  }

  @media only screen and (max-width: 667px) {
    .row-system {
      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }
    .row-top {
      margin-top: 40% !important;
    }
  }

  @media only screen and (max-width: 820px) {
    .row-system {
      img {
        height: 120px;
      }
    }
    .row-table {
      .ant-col-6 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-17 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-offset-1 {
        margin-left: 0 !important;
      }
    }

    .row-top {
      margin-top: 20%;
    }
  }

  @media screen and (max-width: 1280px) {
    .row-contact {
      margin-left: 0;

      .ant-col-8 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-15 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-offset-1 {
        margin-left: 0 !important;
      }
    }

    .row-service {
      margin-left: 0;

      .ant-col-6 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-9 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }
  }

  @media only screen and (max-width: 912px) {
    padding: 150px 80px 0 80px;

    .row-structure {
      .ant-col-8 {
        flex: 0 0 50%;
        max-width: 50%;
      }
    }

    .row-col-branch {
      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-11 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-offset-1 {
        margin-left: 0;
      }
    }
  }

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    padding: 150px 80px 0 80px !important;
  }
`

export const Title = styled.p`
  font-family: 'Noto Sans Thai';
  line-height: 150px;
  font-size: clamp(20px, 2.5vw, 24px);
  text-align: left;
  margin-bottom: 0;
  padding-bottom: 0;

  @media only screen and (max-width: 912px) {
    line-height: 50px !important;
  }

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    line-height: 60px !important;
  }

  @media only screen and (max-width: 1024px) {
    line-height: 70px;
  }

  @media only screen and (min-width: 1440px) {
    line-height: 80px;
  }

  @media only screen and (min-width: 1400px) {
    font-size: 80px;
    line-height: 120px;
  }

  @media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
    font-size: 70px;
  }
  @media screen and (max-width: 1400px) and (orientation: landscape) {
    line-height: 80px;
    font-size: 70px;
  }
`

export const TitleEN = styled.p`
  font-family: 'Brevia Light Italic';
  line-height: 0;
  font-size: clamp(24px, 2.5vw, 35px);
  text-align: left;
  margin-left: 4px;
  line-height: 38px;
`

export const TextSection = styled.p`
  color: var(--black);
  font-family: 'Noto Sans Thai';
  line-height: 35px;
  font-size: clamp(20px, 2.5vw, 24px);
  text-align: left;
  margin-bottom: 20px;
  cursor: pointer;

  @media only screen and (width: 1024px) and (orientation: portrait) {
    line-height: 30px;
  }

  width: fit-content;
  position: relative;
  text-decoration: none;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 4px;
    background-color: var(--secondary);
    bottom: -1px;
    left: 0;
    transform-origin: right;
    transform: scaleX(0);
    transition: transform 0.3s ease-in-out;
  }

  &:hover::before {
    transform-origin: left;
    transform: scaleX(1);
  }
`

export const TextTitle = styled.p`
  color: var(--black);
  font-family: 'Noto Sans Thai Bold';
  line-height: 35px;
  font-size: clamp(30px, 2.5vw, 40px);
  text-align: ${(props) => (props.center ? props.center : 'left')};
  margin-bottom: 25px;
  width: 100%;

  margin-top: ${(props) => (props.top ? props.top : '10px')};
`

export const TextDetail = styled.p`
  color: var(--black);
  font-family: 'Noto Sans Thai';
  line-height: 40px;
  font-size: clamp(20px, 2.5vw, 24px);
  text-align: ${(props) => (props.align ? props.align : 'left')};
  word-break: break-word;
  text-indent: ${(props) => (props.indent ? `${props.indent}px` : '0')};
  margin-bottom: ${(props) => (props.bottom ? props.bottom : '1em')};
  
  a u {
    color: var(--black);
    margin-left: 8px;

    &:hover {
      color: var(--secondary);
    }
  }
`

export const Detail = styled.p`
  color: var(--black);
  font-family: 'Noto Sans Thai';
  font-size: clamp(20px, 2.5vw, 24px);
  line-height: 40px;
  text-align: ${(props) => (props.align ? props.align : 'center')};
  text-indent: ${(props) => props.indent && `${props.indent}px`};
  margin-top: ${(props) => props.top && `${props.top}px`} !important;
  margin-bottom: ${(props) =>
    props.bottom ? `${props.bottom}px` : '32px'} !important;

  span {
    color: var(--black);
  }
`

export const ListImages = styled.div`
  display: flex;
  width: 100%;
  font-family: 'Noto Sans Thai';
  line-height: 40px;
  font-size: clamp(20px, 2.5vw, 24px);
  text-align: left;

  p {
    font-family: 'Noto Sans Thai';
    font-size: clamp(20px, 2.5vw, 24px);
    margin-top: 10px;
  }

  img {
    height: 87px;
    margin-right: 30px;
  }

  @media only screen and (max-width: 414px) {
    img {
      height: 60px;
      margin-right: 20px;
    }
  }
`

export const Float = keyframes`
  0% {
		transform: translatey(0px);
	}
	50% {
		transform: translatey(-20px);
	}
	100% {
		transform: translatey(0px);
	}
`

export const BoxImage = styled.div`
  width: 100%;
  text-align: center;

  p {
    font-family: 'Noto Sans Thai';
    font-size: clamp(20px, 2.5vw, 24px);
    line-height: 40px;
    margin: 0;
    cursor: pointer;
    color: var(--black);
    position: relative;
    z-index: 1;
    width: max-content;

    &:hover {
      color: var(--white);
    }
  }

  p:before {
    transform: scaleX(0);
    transform-origin: bottom right;
  }

  p:hover::before {
    transform: scaleX(1);
    transform-origin: bottom left;
  }

  p::before {
    content: ' ';
    display: block;
    position: absolute;
    top: -10px;
    right: -15px;
    bottom: 0;
    left: -15px;
    height: 54px;
    background: var(--secondary);
    border-radius: 20px;
    z-index: -1;
    transition: transform 0.3s ease;
  }

  img {
    height: 87px;
    margin-bottom: 40px;
  }

  @media only screen and (max-width: 414px) {
    img {
      height: 60px;
      margin-bottom: 40px;
    }
  }

  .icon-course-structure {
    overflow: hidden;
    transform: translatey(0px);
    animation: ${Float} 6s ease-in-out infinite;
  }
`

export const CusttomBreadcrumb = styled(Breadcrumb)`
  span {
    font-family: ${(props) => (props.bold ? 'Noto Sans Thai Bold' : 'Noto Sans Thai')};
    font-size: 16px;
    text-align: left;
  }
`

export const FixBox = styled.div`
  background-color: ${(props) => (props.bg ? props.bg : 'var(--while)')};

  padding: 100px 158px 50px 158px;
  margin: 100px -158px 50px -158px;

  @media only screen and (max-width: 414px) {
    padding: 100px 50px 50px 50px !important;
    margin: 100px -50px 50px -50px !important;
  }

  @media only screen and (max-width: 912px) {
    padding: 100px 80px 50px 80px;
    margin: 100px -80px 50px -80px;
  }

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    padding: 100px 80px 50px 80px !important;
    margin: 100px -80px 50px -80px !important;
  }

  @media only screen and (max-width: 1024px) {
    padding: 100px 110px 50px 110px;
    margin: 100px -110px 50px -110px;
  }

  .row-group {
    margin-top: 0 !important;
  }
`

export const TextHead = styled.p`
  font-family: 'Noto Sans Thai Bold';
  line-height: 50px;
  font-size: clamp(24px, 2.5vw, 35px);
  text-align: left;
  margin-bottom: 10px;

  @media only screen and (max-width: 1024px) {
    margin-top: 80px;
  }
  z-index: 1;
  position: relative;
`

export const Numbers = styled.p`
  font-family: 'Noto Sans Thai';
  line-height: 40px;
  font-size: clamp(24px, 2.5vw, 35px);
  text-align: left;
  display: flex;
  align-items: center;
  position: absolute;
  top: 80px;

  @media only screen and (max-width: 1024px) {
    top: 160px;
  }

  span {
    font-family: 'Brevia Light Italic';
    line-height: 60px;
    text-align: left;
    font-size: clamp(40px, 2.5vw, 60px);
    margin-right: 10px;
    margin-left: 10px;
  }
`

export const NumberList = styled.div`
  display: flex;
  width: 100%;
  font-family: 'Noto Sans Thai';
  font-size: clamp(20px, 2.5vw, 24px);
  text-align: left;
  margin-bottom: 20px;
  align-items: center;
  color: var(--black);

  span {
    color: var(--black) !important;
  }

  .custom-color{
    color: #EC6547 !important;

  }
`

export const ContainerCard = styled.div`
  width: 100%;
  border-radius: 20px;
  /* display: flex;
  justify-content: center; */
  margin-bottom: 20px;
`

export const Box = styled.div`
  width: 100%;
  font-family: 'Noto Sans Thai';
  line-height: 40px;
  font-size: clamp(20px, 2.5vw, 24px);
  text-align: left;
  margin-bottom: 20px;
  align-items: center;
  color: var(--black);

  span {
    color: var(--black) !important;
  }
`

export const TttleSelect = styled.div`
  width: 100%;
  align-items: center;
  display: contents;
  font-family: 'Noto Sans Thai Bold';
  font-size: clamp(20px, 2.5vw, 24px);
  line-height: 50px;
  text-align: left;
  margin-bottom: 20px;
  color: var(--black);
`

const Increase = keyframes`
  100% {
        width: 100%;
    }
 `

export const Line = styled.div`
  border: 1px solid #707070;
  height: 0px;
  width: 1px;
  -webkit-animation: ${Increase} 3s;
  -moz-animation: ${Increase} 3s;
  -o-animation: ${Increase} 3s;
  animation: ${Increase} 3s;
  animation-fill-mode: forwards;
  margin-bottom: 32px;
`

export const SubTitle = styled.p`
  font-family: 'Noto Sans Thai Bold';
  text-align: ${(props) => (props.align ? props.align : 'left')};
  font-size: clamp(22px, 2.5vw, 40px);
  line-height: 50px;
  margin-left: 30px;
  margin-top: ${(props) => props.top && `${props.top}px`} !important;

  @media only screen and (max-width: 414px) {
    margin-top: 50px !important;
    margin-left: 0 !important;
  }

  @media only screen and (min-width: 1440px) {
    margin-bottom: 50px;
  }
`

export const CustomCarousel = styled(Carousel)`
  .slick-dots {
    li {
      width: 26px !important;
      height: 26px !important;
      border-radius: 100% !important;
      background: #fff !important;
      border: 1px solid ${(props) => (props.bg ? props.bg : 'var(--while)')};
      margin: 0 10px !important;
    }

    li.slick-active {
      background: ${(props) =>
        props.bg ? props.bg : 'var(--while)'} !important;
    }

    @media only screen and (max-width: 414px) {
      li {
        width: 13px !important;
        height: 13px !important;
        margin: 0 5px !important;
      }
    }
  }

  .slick-dots {
    li button {
      width: 26px !important;
      height: 26px !important;
      border-radius: 100% !important;
      background: #fff !important;
      border: 1px solid ${(props) => (props.bg ? props.bg : 'var(--while)')};
    }

    li.slick-active button {
      background: ${(props) =>
        props.bg ? props.bg : 'var(--while)'} !important;
    }

    @media only screen and (max-width: 414px) {
      li button {
        width: 13px !important;
        height: 13px !important;
      }
    }
  }

  .slick-dots {
    z-index: 1 !important;
  }
`

export const TextNumber = styled.p`
  font-family: 'Brevia Light Italic';
  line-height: 40px;
  font-size: clamp(20px, 2.5vw, 60px);
  align-items: center;
  display: flex;
  padding-right: 20px;
  margin-left: 30px;
`

export const Exam = styled.p`
  font-family: 'Noto Sans Thai';
  line-height: 25px;
  font-size: 28px;
  margin: 0;
  text-align: center;
  color: var(--black);
  background-color: ${(props) => (props.color ? props.color : '#fff')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 2px solid #fff;
  word-break: break-all;

  span {
    font-family: 'Brevia Light Italic';
    text-align: left;
    font-size: clamp(40px, 2.5vw, 60px);
    margin-left: 10px;
  }
`

export const SubHead = styled.p`
  font-family: 'Noto Sans Thai';
  text-align: ${(props) => (props.align ? props.align : 'left')};
  font-size: clamp(20px, 2.5vw, 24px);
  line-height: 35px;
  display: flex;
  margin-top: ${(props) => (props.top ? `${props.top}px` : 'auto')};
  margin-bottom: ${(props) => (props.bottom ? `${props.bottom}px` : '32px')};

  ${(props) =>
    props.align === 'center' &&
    `
     justify-content: center;
    `}

  a {
    font-family: 'Noto Sans Thai';
    font-size: clamp(20px, 2.5vw, 24px);
    text-align: left;
    line-height: 35px;
    display: flex;
    color: var(--black);
  }

  img {
    cursor: pointer;
    margin-right: 18px;
    height: 36px;
  }
`
